import { link } from "fs";

interface IRoute {
  name: string;
  link: string;
}

export const displayNameMapping: { [key: string]: IRoute } = {
  // '': 'Sign In',
  abha: {
    name: "ABHA",
    link: "/abha",
  },
  hfr: {
    name: "HFR",
    link: "/hfr",
  },
  hpr: {
    name: "HPR",
    link: "/hpr",
  },
  "health-records": {
    name: "Health Records",
    link: "/health-records",
  },
  consent: {
    name: "Consent",
    link: "/consent",
  },
  opd: {
    name: "OPD",
    link: "opd",
  },
  "diagnosis-master": {
    name: "Diagnosis Masters",
    link: "/diagnosis-master?page=1&q=",
  },
  "diagnosis-type": {
    name: "Diagnosis Types",
    link: "/diagnosis-type?page=1&q=",
  },

  Diagnosis: {
    name: "Diagnosis",
    link: "/diagnosis?page=1&q=",
  },

  medicine: {
    name: "Medicine",
    link: "/medicine?page=1&q=",
  },
  "medicine-dose": {
    name: "Medicine Dose",
    link: "/medicine-dose?page=1&q=",
  },

  "medicine-masters": {
    name: "Medicine Masters",
    link: "/medicine-masters?page=1&q=",
  },
  instruction: {
    name: "Instructions",
    link: "/instruction?type=medicine&page=1&q=",
  },
  "medicine-group": {
    name: "Medicine Groups",
    link: "/medicine-group?page=1&q=",
  },
  "medicine-Generic-name": {
    name: "Medicine Generic Names",
    link: "/medicine-Generic-name?page=1&q=",
  },
  "medicine-company": {
    name: "Medicine Companies",
    link: "/medicine-company?page=1&q=",
  },
  "medicine-formulation": {
    name: "Medicine Formulations",
    link: "/medicine-formulation?page=1&q=",
  },
  "medicine-used-as": {
    name: "Medicine Used As",
    link: "/medicine-used-as?page=1&q=",
  },
  "medicine-diluent-name": {
    name: "Medicine Diluent Names",
    link: "/medicine-diluent-name?page=1&q=",
  },
  "medicine-route-of-administration": {
    name: "Medicine Route of Administration",
    link: "/medicine-route-of-administration?page=1&q=",
  },
  "medicine-relation-to-food": {
    name: "Medicine Relation to Food/Sleep",
    link: "/medicine-relation-to-food?page=1&q=",
  },
  "medicine-indication-for-sos-medicine": {
    name: "Medicine Indication for SOS medicine",
    link: "/medicine-indication-for-sos-medicine?page=1&q=",
  },

  "Follow-ups": {
    name: "Follow-ups",
    link: "/Follow-ups?page=1&q=",
  },
  "followup-reason": {
    name: "Follow-up Reasons",
    link: "/followup-reason?page=1&q=",
  },
  "followup-instruction": {
    name: "Follow-up Instructions",
    link: "/followup-instruction?page=1&q=",
  },

  "investigation-master": {
    name: "Investigation Masters",
    link: "/investigation-master",
  },
  // "investigation-maste":{
  //   name:"Investigation Masters",
  //   link:"/investigation-maste",
  // },
  "investigation-sample-collected-from-list": {
    name: "Sample Collected From",
    link: "/investigation-sample-collected-from-list",
  },
  // "investigation-sample-collected-from-list":{
  //   name:"Sample Collected From",
  //   link:"/investigation-sample-collected-from-list",
  // },

  category: {
    name: "Categories",
    link: "/category?page=1",
  },

  doctor: {
    name: "Doctors",
    link: "/doctor?tab=consulting-doctor&page=1&q=",
  },

  symptoms: {
    name: "Symptoms",
    link: "/symptoms?page=1&q=",
  },

  "quick-notes": {
    name: "Quick Notes",
    link: "/quick-notes?type={}&page=1&q=",
  },

  // "notification-template": {
  //   name: "Notification Template",
  //   link: "/notification-template?type={}&isFor={}&q=",
  // },
  "notification-template": {
    name: "Notification Template",
    link: "/notification-template?type={}&isFor={}&page=1&q=",
  },
  "notification-template-save": {
    name: "Notification Template Save",
    link: "/notification-template-save?type={}&isFor={}&q=",
  },

  "notification-list": {
    name: "Notification List",
    link: "/notification-list?type=notification-list&page=1&q=",
  },

  "report-certificate-template": {
    name: "Certificate Template",
    link: "/report-certificate-template?type={}&page=1&q=",
  },
  "report-certificate": {
    name: "Certificate",
    link: "/report-certificate?type={}&page=1&q=",
  },
  "report-certificate-save": {
    name: "Certificate Save",
    link: "/report-certificate-save",
  },
  "follow-up-template": {
    name: "Follow-up Template",
    link: "/follow-up-template?page=1&q=",
  },
  "follow-up-template-save": {
    name: "Follow-up Template Save",
    link: "/follow-up-template-save",
  },
  "examination-template": {
    name: "Examination Template",
    link: "/examination-template?page=1&q=",
  },
  "examination-template-save": {
    name: "Examination Template Save",
    link: "/examination-template-save",
  },

  "history-template": {
    name: "History Template",
    link: "/history-template?page=1&q=",
  },
  "history-template-save": {
    name: "history Template Save",
    link: "/history-template-save",
  },
  "prescription-template": {
    name: "prescription template",
    link: "/prescription-template?page=1&q=",
  },
  "prescription-template-save": {
    name: "prescription template Save",
    link: "/prescription-template-save",
  },

  "diagnosis-template": {
    name: "Diagnosis Template",
    link: "/diagnosis-template?page=1&q=",
  },
  "diagnosis-template-save": {
    name: "Diagnosis Template Save",
    link: "/diagnosis-template-save",
  },
  "fetal-lies": {
    name: "Fetal Lies",
    link: "/fetal-lies?page=1&q=",
  },
  "fetal-presenting-part": {
    name: "Fetal Presenting Part",
    link: "/fetal-presenting-part?page=1&q=",
  },
  "fetal-position": {
    name: "Fetal Position",
    link: "fetal-position?page=1&q=",
  },
  "patient-vaccine-module": {
    name: "Patient Vaccine Module",
    link: "/patient-vaccine-module",
  },
  "patient-vaccine-module-save": {
    name: "Patient Vaccine Module Save",
    link: "/patient-vaccine-module-save",
  },
  "patient-master": {
    name: "Patients",
    link: "/patient-master?page=1&q=",
  },
  "patient-master-save": {
    name: "Patient Save",
    link: "/patient-master/patient-master-save",
  },
  "bill-summary-by-payment": {
    name: "Bill Summary by Payment",
    link: "/report/bill-summary-by-payment",
  },
  "bill-summary-by-patient": {
    name: "Bill Summary by Patient",
    link: "/bill-summary-by-patient",
  },
  "bill-summary-by-patient-detail": {
    name: "Bill Summary",
    link: "/bill-summary-by-patient/bill-summary-by-patient-detail",
  },
  billing: {
    name: "Billing",
    link: "/billing?page=1&fd=&ed=&q=",
  },
  "billing-save": {
    name: "Billing Save",
    link: "/billing/billing-save",
  },
  "payment-received": {
    name: "Payment Received",
    link: "/payment-received?page=1&q=",
  },
  "payment-save": {
    name: "Add Payment",
    link: "/payment-received/payment-save",
  },
};
